var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['aspect-ratio-image', `aspect-ratio-image--${_vm.size}`],style:(_vm.containerStyle)},[_c('UCStoryblokImage',{staticClass:"image",attrs:{"src":_vm.computedImageSrc,"alt":_vm.computedImageAlt,"preload":_vm.preload,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }